/* global goog_report_conversion, AdressCheck */

(function () {
	const zustellerBewerbungData = $(document.currentScript).data();

	window.zustellerBewerbung = new JJK.ZustellerBewerbung(
		'FormZustellerBewerbung',
		null,
		zustellerBewerbungData.verteilschemataErmittelnUrl,
		zustellerBewerbungData.verteilschemataBeiBewerbungVorausgewaehlt
	);

	if (zustellerBewerbungData.mitStrassendatenbankAbgleichen) {
		window.BewerberAdressCheck = new AdressCheck(
			zustellerBewerbungData.liefereStrassenUrl,
			zustellerBewerbungData.liefereOrteUrl,
			zustellerBewerbungData.lieferePlzsUrl,
			zustellerBewerbungData.adresseGueltigUrl,
			undefined,
			zustellerBewerbungData.idForStrasse,
			zustellerBewerbungData.idForHausnummer,
			zustellerBewerbungData.idForOrt,
			zustellerBewerbungData.idForPlz,
			zustellerBewerbungData.strassendatenvorschlagAbXZeichen
		);

		if (zustellerBewerbungData.adressGueltigkeitPruefen) {
			window.BewerberAdressCheck.AdresseGueltig();
		}
	}

	$('#ZustellerBewerbungAbschicken').one('click', () => {
		setTimeout(() => {
			const scrim = new JJK.UI.ScrimmedMessage(`<img src="${window.webAdBaseUrl}Content/images/ajax_loader.gif">`, Strings.DatenUebertragen, 'scrim_FormZustellerBewerbung');
			scrim.show();
		}, '2000');

		if (typeof goog_report_conversion == 'function') {
			goog_report_conversion();
		}
		$('#FormZustellerBewerbung').trigger('submit');
	});

	jjk.initSelect2($('select:not([multiple])'), { width: '100%' });
	jjk.initSelect2($('select[multiple]').attr('title', 'Bitte wählen Sie einen oder mehrere Einträge'), {
		placeholder: 'Bitte wählen Sie einen oder mehrere Einträge',
		width: '100%',
	});
})();
